import { render } from "./HiDialogTrigger.vue?vue&type=template&id=1ea8cce8"
import script from "./HiDialogTrigger.vue?vue&type=script&lang=js"
export * from "./HiDialogTrigger.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__